
import React, { useState, useEffect, ReactElement, useContext } from 'react';
import { getAuthenticationState, IAuthenticationState, runAuthentication, initialState } from './Authentication';
import { Auth0ClientOptions, GetTokenSilentlyOptions, GetUserOptions, RedirectLoginResult } from "@auth0/auth0-spa-js"


interface IProps
{
	children?: ReactElement | ReactElement[],
	onRedirectCallback: (result?: RedirectLoginResult) => void,
	clientOptions: Auth0ClientOptions,
	getUserOptions?: GetUserOptions,
	getTokenSilentlyOptions?: GetTokenSilentlyOptions,
	onAuthencticationFinished?: () => void
}

const AuthenticationContext = React.createContext<IAuthenticationState>(initialState);
export function useAuth() { return useContext(AuthenticationContext); }

export function Auth0Provider(props: IProps)
{
	const [state, setState] = useState<IAuthenticationState>(initialState);

	useEffect(() =>
	{
		async function init()
		{
			const start = Date.now();
			// console.log('running init');
			await runAuthentication(
				props.clientOptions,
				props.onRedirectCallback,
				props.getUserOptions,
				props.getTokenSilentlyOptions
			);

			if (props.onAuthencticationFinished) props.onAuthencticationFinished();

			const end = Date.now();
			// To create some breathing room -> make 750ms the default delay
			// This prevents the loading screen from flashing in your face for less than a second..
			let remainingTime = 750 - (end - start);
			// console.log('remainingTime', remainingTime);
			if (remainingTime < 1) {
				// If the auth took longer than 750 seconds, we don't want to wait any longer..
				remainingTime = 0;
			}

			setTimeout(() =>
			{
				// console.log('init has completed');
				// console.log('auth state', getAuthenticationState());
				setState(getAuthenticationState());
			}, remainingTime);
		}
		init();

		// eslint-disable-next-line
	}, []);

	return (
		<AuthenticationContext.Provider value={state}>
			{props.children}
		</AuthenticationContext.Provider>
	);
}